export interface SelectedOptionsState {
  // number as index of dropdown item
  [layerId: string]: SelectedOptionValue;
}

export type SelectedOptionValue = number | SelectedOptionsSeismicEventValue;

export interface SelectedOptionsSeismicEventValue {
  property: SeismicEventPropertyOptions;
  date: SeismicEventDateOptions;
}

export enum SeismicEventPropertyOptions {
  AGE = "age",
  DEPTH = "depth",
}

export enum SeismicEventAgeColors {
  HOURS = "#ff00b3",
  DAYS = "#ff4141",
  WEEKS = "#ffae00",
  MONTHS = "#fff400",
}

export enum SeismicEventDepthColors {
  LEVEL_1 = "#f8e5ff",
  LEVEL_2 = "#e9b3ff",
  LEVEL_3 = "#d466ff",
  LEVEL_4 = "#a400e6",
  LEVEL_5 = "#6e0099",
}

export enum SeismicEventDateOptions {
  ONE_DAY = "1d",
  ONE_MONTH = "1m",
  TWO_MONTHS = "2m",
  THREE_MONTHS = "3m",
}
